import { render, staticRenderFns } from "./MalattieInfettiveHivList.vue?vue&type=template&id=2a914b4b"
import script from "./MalattieInfettiveHivList.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveHivList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports